<template>
	<div>
		<video class="bg-video" src="/footage/kazima.mp4" autoplay muted loop></video>
		<router-link :to="{name:'dal'}" class="page-nav-link" id="link-right"><img class="link-image" src="images/arrow-up-white-01.png" alt=""></router-link>
		<CircleLink :link-route-name="'yazi'" :link-pos="[600,420]"></CircleLink>

	</div>
</template>

<script>
	import CircleLink from "../components/CircleLink"

	export default {
		name: "KazimaPage",
		components: {CircleLink}
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}

	.page-nav-link {
		position: absolute;
		top: 50%;
	}

	#link-right {
		right: 20px;
	}
</style>